import _ from 'lodash-es';
import APIV5 from '~/models/api';
import Defaults from '~/scripts/constants/defaults';
import Workflow from '~/scripts/services/model/workflow';
import WorkflowNodeAction from '~/scripts/services/model/workflow-node-action';
import Card from '~/scripts/services/model/card';

export default class WfNodeSelectController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} Notification
	 */
	constructor(
		$injector,
		$scope,
		$timeout,
		$translate,
		Notification,
	) {
		this.$injector = $injector;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.Notification = Notification;

		/** @type {any} */
		this.actions = undefined;

		/** @type {any[]} */
		this.data = [];

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		this.index = undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.isa = undefined;

		/** @type {?import('~/components/kform/kform.controller').default} */
		this.kformCtrl = null;

		/** @type {import('~/components/mf/mf.controller').MfOptions} */
		this.mfAllocatorOptions = {
			displayValues: true,
			errors: {
				emptyResults: 'workflow.no-allocator',
			},
		};

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/**
		 * @type {{
		 *   default?: boolean,
		 *   node?: import('@knitiv/api-client-javascript').KNode,
		 *   required?: boolean
		 * }}
		 */
		this.options = {};

		this.state = undefined;

		/** @type {any} */
		this.tmp = {
			allocatorCard: '1-N',
			mfCustom:      {
				selectable: [
					'K_NODE;WF_ROLE',
					'K_NODE;KPROFIL',
				],
			},
			wfCard:        '1-1',
		};

		/** @type {any[]} */
		this.wfList = [];
	}

	/**
	 * @param {any} wf
	 */
	abort(wf) {
		if (!wf.workflowNodeAction) {
			wf.workflowNodeAction = new WorkflowNodeAction();
			this.actions.push(wf.workflowNodeAction);
		}
		wf.workflowNodeAction.action = 'WFAbort';
		wf.workflowNodeAction.wf_affect_kid = wf.wf_affect_kid;
	}

	/**
	 * @param {boolean} ignoreErrors
	 * @returns {Promise<void>}
	 */
	async affect(ignoreErrors = false) {
		if (!Array.isArray(this.data)) {
			this.data = [];
		}

		this.data.push({
			allocator:   [],
			allocators:  [],
			commentaire: '',
			error:       false,
			kid:         null,
			state:       null,
			states:      [],
		});

		if (this.options.default) {
			await this.select({ kid: this.options.default }, this.data.at(-1), ignoreErrors);
			this.data.at(-1).kid = this.options.default;
		}

		this.$timeout(() => {
			this.$scope.$apply();
		}, 100);
	}

	/**
	 * @param {number} index
	 * @param {import('@knitiv/api-client-javascript').KNode} wfKid
	 */
	delete(index, wfKid) {
		_.remove(this.actions, action => action.wf_kid === wfKid);
		this.data.splice(index, 1);
		this.ngModelCtrl?.$setViewValue(this.data);
		this.ngModelCtrl?.$validate();
	}

	deleteAllocator() {
		this.ngModelCtrl?.$validate();
	}

	/**
	 * @param {any} item
	 * @param {any} wf
	 * @param {boolean} ignoreErrors
	 */
	async select(item, wf, ignoreErrors = false) {
		wf.state = null;
		wf.allocators.length = 0;
		wf.states.length = 0;
		wf.allocator.length = 0;

		if (item) {
			if (this.data.some(index => index.kid === item.kid)) {
				if (!ignoreErrors) {
					this.Notification.warning({
						title:   this.$translate.instant('error.title'),
						message: this.$translate.instant('error.wf-already-selected'),
					});
					this.$timeout(() => {
						wf.kid = null;
					});
				}
			}
			else {
				/** @type {any} */
				const w = await APIV5.instance.wfWorkflowLoad(
					{
						wf_kid: item.kid,
						initial: 1,
					}, {
						id: 'wf-node-select.select',
					});
				const workflow = Object.assign(new Workflow(this.$injector, item.kid), w);

				for (const state of workflow.states) {
					if (state.initial === 1) {
						wf.states.push({
							kid:  state.kid,
							name: state.getName(),
						});
					}
				}

				if (workflow.states.length === 1) {
					await this.stateSelect(workflow.states[0], wf);
				}
				else {
					this.ngModelCtrl?.$validate();
				}

				if (wf.states.length === 1) {
					wf.state = wf.states[0].kid;
				}

				this.$timeout(() => this.$scope.$apply());
			}
		}
	}

	/**
	 * @param {any} wf
	 */
	selectAllocator(wf) {
		this.$timeout(() => {
			if (this.actions && Array.isArray(this.actions)) {
				if (!wf.workflowNodeAction) {
					wf.workflowNodeAction = new WorkflowNodeAction();
					wf.workflowNodeAction.setScope(this.$scope, wf);
					this.actions.push(wf.workflowNodeAction);
				}
				wf.workflowNodeAction.action = 'WFAffect';
				wf.workflowNodeAction.node_kid = this.options.node;
				wf.workflowNodeAction.wf_kid = wf.kid;
				wf.workflowNodeAction.wfstate_kid = wf.state;
				wf.workflowNodeAction.wfallocatorlist = wf.allocator.map((/** @type {any} */ allocator) => allocator.kid);
				wf.workflowNodeAction.wfcomment = wf.wfcomment;
			}
			this.ngModelCtrl?.$validate();
		});
	}

	stateDelete() {
		this.$timeout(() => {
			this.ngModelCtrl?.$setViewValue(this.data);
			this.ngModelCtrl?.$validate();
		});
	}

	/**
	 * @param {any} wf
	 * @returns {boolean}
	 */
	stateGetName(wf) {
		const state = wf.states.filter((/** @type {any} */ s) => s.kid === wf.state);
		return state.length === 1 ? state[0].name : '';
	}

	/**
	 * @param {import('~/scripts/services/model/state').default} state
	 * @param {any} wf
	 */
	async stateSelect(state, wf) {
		wf.allocators.length = 0;
		wf.allocator.length = 0;
		this.ngModelCtrl?.$setDirty();
		this.ngModelCtrl?.$setTouched();

		if (state?.kid) {
			/** @type {Partial<import('@knitiv/api-client-javascript').WFAffectGetStateInfoInput>} */
			const stateParameters = {
				wfaction_kid: 'K_NODE;WFAC_INITIAL',
				wfstate_kid: state.kid,
				...(this.options.node && !this.form?.create
					? { element_kid: this.options.node }
					: (this.isa
						? { element_isa: this.isa }
						: {})),
			};

			/** @type {import('@knitiv/api-client-javascript').WFAffectGetStateInfoOutput} */
			const result = await APIV5.instance.wfAffectGetStateInfo(stateParameters, { id: 'wf-node-select.state-select' },
			);
			wf.stateAffectAuto = result.wfstate.affectAuto;
			wf.allocators.push(...result.wfallocatorlist);

			if (result.wfstate?.kndef?.validate) {
				this.tmp.allocatorCard = `${result.wfstate.kndef.validate.min ?? '1'}-`
					+ `${result.wfstate.kndef.validate.max && result.wfstate.kndef.validate.max !== 'N'
						? result.wfstate.kndef.validate.max : Defaults.KCARDN}`;
			}

			if (wf.stateAffectAuto || wf.allocators.length === 1 && wf.allocators[0].kid !== 'K_NODE;KR_WF_TOUS') {
				wf.allocator.push(...wf.allocators);
				this.selectAllocator(wf);
			}

			this.$timeout(() => {
				this.$scope.$apply();
				this.ngModelCtrl?.$validate();
			});
		}
		else {
			this.ngModelCtrl?.$validate();
		}
	}

	$onInit() {
		this.$scope.$watch('$ctrl.options.required', (/** @type {boolean} */ required) => {
			this.tmp.wfCard = required ? '1-1' : '0-1';
			this.tmp.wfPlaceholder = required
				? this.$translate.instant('object.workflow')
				: this.$translate.instant('object.workflow-optional');
		});

		this.$scope.$watch('$ctrl.options.list', (/** @type {string[] | undefined} */ items) => {
			this.wfList.length = 0;

			if (Array.isArray(items)) {
				APIV5.instance.repreListSimple({ items, mode: 'simple' }, { id: 'wf-node-select.list-modified' })
					.then((/** @type {any} */ result) => {
						for (const [kid, name] of Object.entries(result.result)) {
							this.wfList.push({ kid, name });
						}
						return this.wfList;
					})
					.catch((/** @type {any} */ error) => console.error(error));
			}
		});

		if (this.ngModelCtrl) {
			this.ngModelCtrl.$validators.stateRequired = (/** @type {any} */ modelValue) => {
				let valid = true;
				if (Array.isArray(modelValue)) {
					for (const wf of modelValue) {
						wf.error = false;
						if (wf.kid && !wf.state) {
							valid = false;
							wf.error = true;
						}
					}
				}

				return valid;
			};

			this.ngModelCtrl.$validators.wfRequired = (/** @type {any} */ modelValue) => {
				let valid = Array.isArray(modelValue);

				if (valid && this.options.required) {
					if (modelValue.length === 0) {
						valid = false;
					}
					else {
						for (const wf of modelValue) {
							wf.error = false;
							if (!wf.kid) {
								valid = false;
								wf.error = true;
							}
						}
					}
				}
				this.form?.formio?.kformForm.$setValidity('wfRequired', valid, this.form?.formio?.kformForm);

				return valid;
			};

			this.ngModelCtrl.$validators.wfAllocatorsMin = (/** @type {any} */ modelValue) => {
				let valid = Array.isArray(modelValue);
				const allocatorCard = new Card(this.tmp.allocatorCard);
				if (valid) {
					for (const wf of modelValue) {
						wf.error = wf.kid ? wf.allocator.length < allocatorCard.from : false;
					}
					valid = modelValue.every((/** @type {any} */ wf) => wf.error === false);
				}

				this.form?.formio?.kformForm.$setValidity('wfAllocatorsMin', valid, this.form?.formio?.kformForm);
				return valid;
			};

			this.ngModelCtrl.$validators.wfAllocatorsMax = (/** @type {any} */ modelValue) => {
				let valid = Array.isArray(modelValue);
				const allocatorCard = new Card(this.tmp.allocatorCard);

				if (valid) {
					for (const wf of modelValue) {
						wf.error = false;
						if (!wf.stateAffectAuto && wf.allocator.length > allocatorCard.to) {
							valid = false;
							wf.error = true;
						}
					}
				}

				this.form?.formio?.kformForm.$setValidity('wfAllocatorsMax', valid, this.form?.formio?.kformForm);
				return valid;
			};
		}

		// this.options.wfAffect = this.affect;
		if (
			(this.form && !this.form.workflow.some(workflow => workflow.kid === this.form?.wf.default))
			|| this.options.default
		) {
			(async () => this.affect(true))();
		}
	}
}
